     <fury-page>
        <fury-title class="title">
          <span *ngIf="!isSubmitTypeAdd" [@fadeInRight]>Update Menu</span>
          <span *ngIf="isSubmitTypeAdd" [@fadeInRight]>Add Menu</span>
        </fury-title>
      </fury-page>
  
      <div fxLayout="column" fxLayoutAlign="start center">
        <div [@fadeInUp] class="card">
          <form [formGroup]="menuForm" style="width: 100%;">
            <div class="content" fxLayout="column" fxLayoutGap="8px">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Title</mat-label>
                <input matInput placeholder="Title" formControlName="title">
                <mat-error *ngIf="menuForm.controls['title'].touched && menuForm.controls['title'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Frontend Component Name</mat-label>
                <input matInput placeholder="Frontend Component Name" formControlName="frontendComponentName">
                <mat-error *ngIf="menuForm.controls['frontendComponentName'].touched && menuForm.controls['frontendComponentName'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Backend Component Name</mat-label>
                <input matInput placeholder="Backend Controller Name" formControlName="backendComponentName">
                <mat-error *ngIf="menuForm.controls['backendComponentName'].touched && menuForm.controls['backendComponentName'].hasError('required')">
                    This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Description</mat-label>
                <textarea matInput placeholder="Description" formControlName="description"></textarea>
                <mat-error
                  *ngIf="menuForm.controls['description'].touched && menuForm.controls['description'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Parent</mat-label>
                <mat-select formControlName="parentId">
                  <mat-option value="">N/A</mat-option>
                  <mat-option *ngFor="let item of menuList" [value]="item?.adminMenuId">{{item?.title}}</mat-option>
  
                </mat-select>
                <mat-error *ngIf="menuForm.controls['parentId'].touched && menuForm.controls['parentId'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Is Active</mat-label>
                <mat-select formControlName="isActive">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
                <mat-error *ngIf="menuForm.controls['isActive'].touched && menuForm.controls['isActive'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            </div>

            <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
              <button mat-button type="button" class="sub-button" (click)="addEditMenu()"><span>{{isSubmitTypeAdd ? 'Add' : 'Update'}}</span></button>
              <button mat-button type="button" class="can-button" (click)="this.location.back()"><span>Cancel</span></button>
            </div>
            
          
            <!-- <div class="form-fld text-center">
              <div class="actionControl">
                <button type="button" class="submit-btn" (click)="addEditMenu()"><span>{{isSubmitTypeAdd ? 'Add' : 'Update'}}</span></button>
              </div>
              <div class="actionControl mr-2">
                <button type="button" class="submit-btn" (click)="this.location.back()"><span>Cancel</span></button>
              </div>
            </div> -->
          </form>
      </div>
   </div>


